import { initExtraQuestionBlock } from '../../../helpers';

/**
 * Init click to proceed for radio buttons in the form
 */
export function initClickToProceed() {
	const $form = window.modForm.opts.form;

	if (window.modForm.opts.extraQuestionBlock) {
		window.modForm.opts.extraQuestionInputs.forEach(($input) => {
			if ($input) {
				$input.removeAttribute('data-required');
			}
		});
	}

	$form.querySelectorAll('input[type="radio"]').forEach(function($radio) {
		$radio.addEventListener('click', function(e) {
			e.stopImmediatePropagation();
			if (window.modForm.radioButtonClickedByMouse) {
				initExtraQuestionBlock(this);
				window.modForm.radioButtonClickedByMouse = false;
			}
		});

		if (window.modForm.opts.extraQuestionBlock) {
			$radio.addEventListener('keypress', function(e) {
				e.stopImmediatePropagation();
				if (e.keyCode === 13 || e.key === 'Enter') {
					initExtraQuestionBlock(this);
				}
			});
		}
	});
}
